module.exports = __webpack_public_path__ + "static/media/default-barber.bcb59459.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/default-barber.jpg
// module id = 1820
// module chunks = 0